/**
 * Retrieves a section using the Section Rendering API
 *
 * @param {String} url - URL of the section to return
 * @returns HTMLElement
 */
const fetchSection = (url) =>
  fetch(url)
    .then((res) => res.text())
    .then((html) =>
      new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('.shopify-section')
    )


class VariantSelectors extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);

    this.handle = this.dataset.handle;
    this.sectionId = this.dataset.sectionId;
    
    this.selects = this.querySelectorAll('select');
    this.form = this.closest('form');
    this.variantInput = this.form ? this.form.querySelector('input[name="id"]') : null;

    this.initializeVariant();
  }

  initializeVariant() {
    this.variantData = this.getVariantData();
    
    if (this.variantData.length === 1) {
      this.currentVariant = this.variantData[0];
    } else {
      this.updateOptions();
      this.updateMasterId();
    }

    if (this.currentVariant) {
      this.updateVariantInput();
      this.updatePrice();
    }
  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();

    if (this.currentVariant) {
      this.updatePrice();
      this.updateVariantInput();
    }
  }

  updateOptions() {
    this.options = Array.from(this.selects, (select) => select.value);
  }

  updateMasterId() {
    this.variantData = this.getVariantData();
    this.currentVariant = this.variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateVariantInput() {
    if (this.form && this.variantInput && this.currentVariant) {
      this.variantInput.value = this.currentVariant.id;
      this.variantInput.disabled = false;
      
      this.dispatchEvent(new CustomEvent('variant:changed', {
        bubbles: true,
        detail: {
          variant: this.currentVariant,
          form: this.form
        }
      }));
    }
  }

  updatePrice() {
    if (!this.currentVariant) return;
    
    const priceElement = this.querySelector('[data-product-price]');
    const comparePriceElement = this.querySelector('[data-compare-price]');
    
    // Format money function that handles decimals properly
    const formatMoney = (cents, currency) => {
      const amount = (cents / 100).toFixed(2);
      // Remove trailing zeros if whole number
      const formattedAmount = amount.replace(/\.00$/, '');
      return `${currency}${formattedAmount}`;
    };
    
    if (priceElement) {
      const currency = priceElement.dataset.currency || '£';
      priceElement.textContent = formatMoney(this.currentVariant.price, currency);
    }
    
    // Update compare at price if it exists and is greater than current price
    if (comparePriceElement) {
      const currency = comparePriceElement.dataset.currency || '£';
      
      if (this.currentVariant.compare_at_price && this.currentVariant.compare_at_price > this.currentVariant.price) {
        comparePriceElement.textContent = formatMoney(this.currentVariant.compare_at_price, currency);
        comparePriceElement.style.display = '';
      } else {
        comparePriceElement.style.display = 'none';
      }
    }
  }

  async fetchVariantData() {
    const html = await fetchSection(
      `/products/${this.handle}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`
    ).then((section) => section.innerHTML)

    document.querySelector('.main-product').innerHTML = html

    try {
      window.shopifyWishlist.initButtons();
    } catch (e) {
    }

    window.history.replaceState(null, null, `?variant=${this.currentVariant.id}` );
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  openSizeGuide() {
    document.querySelector('[data-size-guide]').classList.remove('opacity-0', 'pointer-events-none');
    document.querySelector('[data-size-overlay]').classList.remove('opacity-0', 'pointer-events-none');
    document.querySelector('[data-size-overlay]').classList.add('opacity-60');
    document.querySelector('body').classList.add('overflow-hidden');
  }

  closeSizeGuide() {
    document.querySelector('[data-size-guide]').classList.add('opacity-0', 'pointer-events-none');
    document.querySelector('[data-size-overlay]').classList.add('opacity-0', 'pointer-events-none');
    document.querySelector('[data-size-overlay]').classList.remove('opacity-60');
    document.querySelector('body').classList.remove('overflow-hidden');
  }
}

customElements.define('variant-selectors', VariantSelectors);